import { Injectable } from '@angular/core';
import { AbstractEntityService } from '@app/shared/abstract/abstract-entity.service';
import { HttpClient, HttpParams } from '@angular/common/http';
import { UserModel } from '@app/users/shared/user.model';
import { NoteModel } from '@app/events/shared/note.model';
import { ResourceData } from '@app/shared/abstract/resource.data';
import { Observable } from 'rxjs';

/**
 * TVG-318: a contact the Add Contact form found before saving, so staff can
 * open it instead of creating a duplicate.
 */
export interface ExistingContactMatch {
  id: number;
  name: string;
  email: string;
  exact_email_match: boolean;
}

@Injectable({
  providedIn: 'root',
})
export class ContactService extends AbstractEntityService<UserModel> {
  constructor(http: HttpClient) {
    super('/api/contacts', http);
  }

  fieldIsUnique(field: string, value: string): Observable<{ is_unique: boolean }> {
    return this.http.get<{ is_unique: boolean }>(`${this.apiUrl}${this.basePath}/unique?field=${field}&value=${value}`);
  }

  /**
   * TVG-318: look for contacts that already exist before the Add Contact form
   * creates a new one.
   */
  searchExisting(name: string, email: string): Observable<{ data: ExistingContactMatch[] }> {
    const params = new HttpParams().set('name', name ?? '').set('email', email ?? '');

    return this.http.get<{ data: ExistingContactMatch[] }>(`${this.apiUrl}${this.basePath}/search`, { params });
  }

  createContactNote(data: any) {
    return this.http.post<ResourceData<NoteModel>>(`${this.apiUrl}/api/notes`, data);
  }

  deleteContactNote(id: number) {
    return this.http.delete<ResourceData<NoteModel>>(`${this.apiUrl}/api/notes/${id}`);
  }

  updateContactNote(data: any, id: number) {
    return this.http.put<ResourceData<NoteModel>>(`${this.apiUrl}/api/notes/${id}`, data);
  }
}
